"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InstructionsList = InstructionsList;
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _Card2 = _interopRequireDefault(require("@mui/material/Card"));
var _CardContent2 = _interopRequireDefault(require("@mui/material/CardContent"));
var _ExpandMore2 = _interopRequireDefault(require("@mui/icons-material/ExpandMore"));
var _ExpandLess2 = _interopRequireDefault(require("@mui/icons-material/ExpandLess"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = require("styled-components");
var _button = require("../button");
var _section = _interopRequireDefault(require("./section"));
var _sectionCard = _interopRequireDefault(require("./section-card"));
var _wayPoint = _interopRequireDefault(require("./way-point"));
var _wayPointCard = _interopRequireDefault(require("./way-point-card"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function InstructionListContent({
  disableHeader,
  route,
  bikeStationsMap,
  instructionsShowed,
  onInstructionsShowed,
  onInstructionsHidden,
  onHighlight,
  variant
}) {
  const [sectionDetailsShowed, showSectionDetails] = (0, _react.useState)({});
  (0, _react.useEffect)(() => {
    if (route && !variant) {
      route.sections.forEach((_, sectionIndex) => {
        showSectionDetails({
          ...sectionDetailsShowed,
          [sectionIndex]: true
        });
      });
    } else {
      showSectionDetails({});
    }
  }, [route, instructionsShowed]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !disableHeader && /*#__PURE__*/_react.default.createElement(StyledHeader, {
    style: {
      marginBottom: variant ? '16px' : '24px'
    }
  }, variant ? /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    noWrap: true,
    fontSize: "1.125rem",
    fontWeight: 700,
    variant: "h6"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.routing.roadmap.title"
  })) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    noWrap: true,
    variant: "h6"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.routing.roadmap.title"
  })), instructionsShowed ? /*#__PURE__*/_react.default.createElement(_button.Button, {
    endIcon: /*#__PURE__*/_react.default.createElement(_ExpandLess2.default, null),
    onClick: onInstructionsHidden,
    variant: "outlined"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.actions.hide_details"
  })) : /*#__PURE__*/_react.default.createElement(_button.Button, {
    color: "primary",
    disabled: !route,
    endIcon: /*#__PURE__*/_react.default.createElement(_ExpandMore2.default, null),
    onClick: onInstructionsShowed,
    variant: "outlined"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.actions.see_details"
  })))), route && (instructionsShowed || variant) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, variant ? /*#__PURE__*/_react.default.createElement(_Card2.default, null, /*#__PURE__*/_react.default.createElement(_CardContent2.default, null, route.sections.map((_, sectionIndex) => /*#__PURE__*/_react.default.createElement(SectionWrapper, {
    key: sectionIndex
  }, /*#__PURE__*/_react.default.createElement(_wayPoint.default, {
    bikeStationsMap: bikeStationsMap || {},
    route: route,
    sectionIndex: sectionIndex
  }), /*#__PURE__*/_react.default.createElement(_section.default, {
    detailsShowed: sectionDetailsShowed[sectionIndex],
    handleDetailsShowed: showed => showSectionDetails({
      ...sectionDetailsShowed,
      [sectionIndex]: showed
    }),
    handleHighlight: onHighlight,
    route: route,
    sectionIndex: sectionIndex
  }), sectionIndex === route.sections.length - 1 && /*#__PURE__*/_react.default.createElement(_wayPoint.default, {
    isArrival: true,
    bikeStationsMap: bikeStationsMap || {},
    route: route,
    sectionIndex: sectionIndex
  }))))) : /*#__PURE__*/_react.default.createElement(StyledContent, null, route.sections.map((_, sectionIndex) => /*#__PURE__*/_react.default.createElement(SectionWrapper, {
    key: sectionIndex
  }, /*#__PURE__*/_react.default.createElement(_wayPointCard.default, {
    bikeStationsMap: bikeStationsMap || {},
    route: route,
    sectionIndex: sectionIndex
  }), /*#__PURE__*/_react.default.createElement(_sectionCard.default, {
    detailsShowed: sectionDetailsShowed[sectionIndex],
    handleDetailsShowed: showed => showSectionDetails({
      ...sectionDetailsShowed,
      [sectionIndex]: showed
    }),
    handleHighlight: onHighlight,
    route: route,
    sectionIndex: sectionIndex
  }), sectionIndex === route.sections.length - 1 && /*#__PURE__*/_react.default.createElement(_wayPointCard.default, {
    isArrival: true,
    bikeStationsMap: bikeStationsMap || {},
    route: route,
    sectionIndex: sectionIndex
  }))))));
}
function InstructionsList({
  ...props
}) {
  const {
    instructionsShowed,
    variant
  } = props;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, variant ? /*#__PURE__*/_react.default.createElement(_Box2.default, null, /*#__PURE__*/_react.default.createElement(InstructionListContent, props)) : /*#__PURE__*/_react.default.createElement(_Card2.default, {
    sx: {
      borderRadius: 2,
      backgroundColor: instructionsShowed ? 'transparent' : 'initial'
    },
    variant: "outlined"
  }, /*#__PURE__*/_react.default.createElement(_CardContent2.default, null, /*#__PURE__*/_react.default.createElement(InstructionListContent, props))));
}
const StyledHeader = _styledComponents.styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  height: 36px;

  > *:not(:first-child) {
    margin-left: 16px;
  }
`;
const StyledContent = _styledComponents.styled.div`
  position: relative;

  &::before {
    bottom: 40px;
    border: 1px dashed #ccc;
    content: '';
    left: 11px;
    position: absolute;
    top: 32px;
  }
`;
const SectionWrapper = _styledComponents.styled.div`
  &:not(:first-child) {
    margin: 24px 0 0 0;
  }
`;